/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs */

const es_marketplace_seo_galicia_guide_mussels_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una experiencia muy popular en las rías es el paseo en barco entre bateas de mejillón con degustación fresca a bordo. Combina navegación tranquila, paisaje de raíles flotantes y marisco de la zona.`)
};

const gl_marketplace_seo_galicia_guide_mussels_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unha experiencia moi popular nas rías é o paseo en barco entre bateas de mexillón con degustación fresca a bordo. Combina navegación tranquila, paisaxe de raios flotantes e marisco da zona.`)
};

const en_marketplace_seo_galicia_guide_mussels_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A popular ria experience is a boat tour among mussel rafts with fresh tasting on board. It combines calm sailing, floating farm scenery and local seafood.`)
};

/**
* | output |
* | --- |
* | "A popular ria experience is a boat tour among mussel rafts with fresh tasting on board. It combines calm sailing, floating farm scenery and local seafood." |
*
* @param {Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_mussels_p1 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Mussels_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_mussels_p1(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_mussels_p1(inputs)
	return es_marketplace_seo_galicia_guide_mussels_p1(inputs)
});